import React, { useState, useEffect } from 'react';
import $i18n from '@/i18n';
import store from '@/store';
import { copy } from '@/utils/config';
import { Icon } from '@b-design/fusion';
import Requests from '@/services/request';
import { Message } from '@b-design/fusion';
import { PaletteTool } from '@b-design/color';
import CommonHeader from '@/components/CommonHeader';
import { getQueryStringArgs } from '@/utils/url-parse';
import { Form, Input, Upload, UploadFile, Spin, Popover, Modal, Progress } from 'antd';
import Button from '@/components/Button';

import {
  QuestionCircleOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import './index.less';

const breadcrumbConfig = [
  {
    key: 'platformInfoSettings',
    breadcrumbName: $i18n.get({ id: 'aopf.pages.platformInfoSettings.Settings', dm: '设置' }),
    path: '/platformInfoSettings',
  },
];

const PlatformInfoSettings = () => {
  const [form] = Form.useForm();
  const { spaceId } = getQueryStringArgs();
  const [userState] = store.useModel('user');
  const [config, setConfig] = useState<any>({}); // 配置信息
  const [loading, setLoading] = useState(false); // loading
  const [saveLoading, setSaveLoading] = useState(false); // 保存loading
  const [dnsLoading, setDnsLoading] = useState(false); // 获取DNS loading
  const [[viewVisible, viewType], setView] = useState([false, '']); // 查看案例
  const [guideVisible, setGuideVisible] = useState(false);
  const [notInvalid, setNotInvalid] = useState(false); // 未完成域名所有权验证

  const querySaveConfig = () => {
    form
      .validateFields()
      .then((values) => {
        if (!values?.cname) {
          Message.error(
            $i18n.get({ id: 'aopf.pages.platformInfoSettings.ObtainDns', dm: '请获取DNS' }),
          );
          return;
        }
        if (notInvalid) {
          Message.error(
            $i18n.get({
              id: 'aopf.pages.platformInfoSettings.YouHaveNotCompletedThe',
              dm: '您尚未完成域名所有权的验证，无法获取DNS信息，请先完成域名所有权验证后重试。',
            }),
          );
          return;
        }
        const { primaryColor, cname } = values;
        if (!cname) {
          Message.error(
            $i18n.get({ id: 'aopf.pages.platformInfoSettings.ObtainDns', dm: '请获取DNS' }),
          );
          return;
        }
        let themeColors;
        if (primaryColor) {
          try {
            const colors = PaletteTool.generate(primaryColor) || [];
            // primary100-primary10
            const primaryIndex = colors.findIndex(
              (v) => v.toLocaleLowerCase() === primaryColor.toLocaleLowerCase(),
            );
            themeColors = {
              secondary1: colors[9], //取primary10
              secondary2: colors[8], //取primary20
              primary3: colors[primaryIndex + 2] || colors[9], //当前色阶-20，如用户输入色值对应的是primary70，则此参数对应的是primary50的色值；边界值情况，如用户输入色值对应的是primary20，则此参数对应primary10; 如用户输入色值对应的是primary10，则此参数对应primary10
              primary2: colors[primaryIndex + 1] || colors[9], //当前色阶-10，如用户输入色值对应的是primary70，则此参数对应的是primary60的色值；边界值情况，如用户输入色值对应的是primary10，则此参数对应primary10
              primary1: primaryColor, //用户在设置页填入值
              active1: colors[primaryIndex - 1] || colors[0], //当前色阶+10，如用户输入色值对应的是primary60，则此参数对应的是primary70的色值；边界值情况，如用户输入色值对应的是primary100，则此参数对应primary100
              active2: colors[primaryIndex - 2] || colors[0], //当前色阶+20，如用户输入色值对应的是primary60，则此参数对应的是primary80的色值；边界值情况，如用户输入色值对应的是primary100，则此参数对应primary100; 如用户输入色值对应的是primary90，则此参数对应primary100
              active3: colors[primaryIndex - 3] || colors[0], //当前色阶+30，，如用户输入色值对应的是primary60，则此参数对应的是primary90的色值；边界值情况，如用户输入色值对应的是primary100，则此参数对应primary100; 如用户输入色值对应的是primary90，则此参数对应primary100; 如用户输入色值对应的是primary80，则此参数对应primary100;
            };
          } catch (error) {
            console.error('PaletteTool error: ', error);
          }
        }
        setSaveLoading(true);
        Requests.post('/rest/intercnn/siteConfig/saveConfig', {
          ...values,
          spaceId,
          themeColors: themeColors || {},
          sslCertPath: values.sslCertPath?.[0]?.url || '',
          sslKeyPath: values.sslKeyPath?.[0]?.url || '',
          brandLogoPath: values.brandLogoPath?.[0]?.url || '',
          termsServicePath: values.termsServicePath?.[0]?.url || '',
          privacyPolicyPath: values.privacyPolicyPath?.[0]?.url || '',
          loginImgPath: values.loginImgPath?.[0]?.url || '',
        })
          .then((data) => {
            if (data) {
              Message.success(
                $i18n.get({
                  id: 'aopf.pages.platformInfoSettings.SavedSuccessfully',
                  dm: '保存成功',
                }),
              );
            }
            setSaveLoading(false);
          })
          .catch(() => {
            setSaveLoading(false);
          });
      })
      .catch(() => {});
  };

  const updateFormValues = (data) => {
    const _config: any = data || {};
    form.setFieldsValue({
      ..._config,
      primaryColor: _config?.themeColors?.primary1 || '',
      brandLogoPath: !_config?.brandLogoPath
        ? []
        : [
            {
              status: 'done',
              percent: 100,
              url: _config.brandLogoPath,
              name: _config.brandLogoPath,
              publicUrl: _config.brandLogoPublicPath,
            },
          ],

      loginImgPath: !_config?.loginImgPath
        ? []
        : [
            {
              status: 'done',
              percent: 100,
              url: _config.loginImgPath,
              name: _config.loginImgPath,
              publicUrl: _config.loginImgPublicPath,
            },
          ],

      termsServicePath: !_config?.termsServicePath
        ? []
        : [
            {
              status: 'done',
              percent: 100,
              url: _config.termsServicePath,
              name: _config.termsServicePath,
              publicUrl: _config.termsServicePublicPath,
            },
          ],

      privacyPolicyPath: !_config?.privacyPolicyPath
        ? []
        : [
            {
              status: 'done',
              percent: 100,
              url: _config.privacyPolicyPath,
              name: _config.privacyPolicyPath,
              publicUrl: _config.privacyPolicyPublicPath,
            },
          ],

      sslKeyPath: !_config?.sslKeyPath
        ? []
        : [
            {
              status: 'done',
              percent: 100,
              url: _config.sslKeyPath,
              name: _config.sslKeyPath,
            },
          ],

      sslCertPath: !_config?.sslCertPath
        ? []
        : [
            {
              status: 'done',
              percent: 100,
              url: _config.sslCertPath,
              name: _config.sslCertPath,
            },
          ],
    });
  };

  // TODO Settings 查询配置信息
  const queryConfig = () => {
    setLoading(true);
    Requests.get('/rest/intercnn/siteConfig/queryConfig', { spaceId })
      .then((data) => {
        setConfig(data || {});
        updateFormValues(data || {});
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // TODO Settings 获取DNS
  const queryDns = () => {
    form
      .validateFields(['domain', 'sslCertPath', 'sslKeyPath'])
      .then((values) => {
        setDnsLoading(true);
        Requests.post('/rest/intercnn/siteConfig/configWaf', {
          spaceId,
          domain: values.domain,
          sslCertPath: values.sslCertPath?.[0]?.url,
          sslKeyPath: values.sslKeyPath?.[0]?.url,
        })
          .then((data) => {
            setDnsLoading(false);
            setNotInvalid(false);
            setConfig(
              Object.assign({}, config, {
                domain: values.domain,
                sslCertPath: values.sslCertPath?.[0]?.url,
                sslKeyPath: values.sslKeyPath?.[0]?.url,
              }),
            );
            if (data?.cname) {
              form.setFieldsValue({
                cname: data.cname,
                id: data?.id,
              });
            }
          })
          .catch((error) => {
            if (error?.errorCode === 'CREAT_WAF_ERROR') {
              setNotInvalid(true);
            }
            setDnsLoading(false);
          });
      })
      .catch(() => {});
  };

  useEffect(() => {
    if(!spaceId) return;
    document.title = $i18n.get({
      id: 'aopf.pages.platformInfoSettings.Settings',
      dm: $i18n.get({ id: 'aopf.src.pages.layout.Settings', dm: '设置' }),
    });
    queryConfig();
    const isFirst = !localStorage.getItem('alreadyVisitedTheSettingsPage');
    if (!isFirst) {
      return;
    }
    localStorage.setItem(
      'alreadyVisitedTheSettingsPage',
      `${new Date().valueOf()}_${userState?.currentUser?.accountId || ''}`,
    );
    setGuideVisible(true);
  }, [spaceId]);

  const commonUploadConfig = {
    valuePropName: 'fileList',
    getValueFromEvent: (e: any) => {
      const _fileList = (Array.isArray(e) ? e : e?.fileList || [])?.filter(
        (item: any) => item.status !== 'error' || item.response?.status === 200,
      );

      _fileList.forEach((item: any) => {
        if (item.status === 'done') {
          item.publicUrl = item.publicUrl || item.response?.data?.publicUrl || '';
          item.url = item.url || item.response?.data?.relativePath || '';
        }
      });

      return _fileList;
    },
  };

  const getUploadConfig = (_accept, _maxSize, _upLoadType) => {
    return {
      // TODO Settings
      action: '/rest/intercnn/common/upload',
      headers: {
        authorization: 'authorization-text',
      },
      name: 'file',
      method: 'post',
      data: {
        // SSL_CERT(证书公钥)、SSL_KEY(证书私钥)、LOGO（logo）、LOGIN_IMG(登录页图片)、TERMS_SERVICE（服务协议）、PRIVACY_POLICY（隐私条款）
        type: _upLoadType,
        spaceId,
      },
      multiple: false,
      maxCount: 1,
      showUploadList: {
        showDownloadIcon: true,
      },
      itemRender: (_originNode, _file, fileList, actions) => {
        const { remove } = actions;
        return (
          <>
            {fileList.map((item: any) => (
              <div className="custom-upload-item-wrapper">
                <div className="custom-upload-item">
                  <div className="upload-item-name-wrapper">
                    <Icon type="attachment" size="small" />
                    <Popover
                      content={
                        <div
                          style={{
                            maxWidth: '310px',
                            fontSize: '12px',
                            lineHeight: '16px',
                            color: '#474A52',
                            wordBreak: 'break-all',
                          }}
                        >
                          {item.name}
                        </div>
                      }
                    >
                      <div className="upload-item-name">{item.name}</div>
                    </Popover>
                  </div>
                  <div className="upload-item-actions">
                    {item.status === 'done' &&
                      _upLoadType !== 'SSL_CERT' &&
                      _upLoadType !== 'SSL_KEY' && (
                        <Icon
                          type="download"
                          size="xs"
                          onClick={() => window.open(`${item.publicUrl || ''}`)}
                        />
                      )}

                    <Icon type="trash-can--outline" size="xs" onClick={() => remove(item)} />
                  </div>
                </div>
                {item.status === 'uploading' && item.percent !== 100 && (
                  <div className="upload-item-progress">
                    <Progress percent={item.percent} showInfo={false} strokeWidth={2} />
                  </div>
                )}
              </div>
            ))}
          </>
        );
      },
      withCredentials: true,
      accept: _accept?.join(','),
      beforeUpload: (_file: UploadFile) => {
        const { size = 0, name } = _file;
        const nameList = name?.split('.') || [];
        const fileType = nameList[nameList.length - 1]?.toLocaleLowerCase();

        if (_accept?.length && !_accept.includes(`.${fileType}`)) {
          // 校验格式
          Message.warning(
            $i18n.get(
              {
                id: 'aopf.pages.platformInfoSettings.AcceptedFileFormatsAre',
                dm: '仅支持{accept}格式的文件，请重新上传',
              },
              { accept: _accept?.join(', ') },
            ),
          );
          return Upload.LIST_IGNORE;
        }

        if (_maxSize && size > _maxSize * 1024) {
          Message.warning(
            $i18n.get(
              {
                id: 'aopf.pages.platformInfoSettings.TheFileSizeCannotExceed',
                dm: '文件大小不能超过{maxSize}KB',
              },
              { maxSize: _maxSize },
            ),
          );
          return Upload.LIST_IGNORE;
        }

        return true;
      },
      onChange: (info: any) => {
        const { file = {}, fileList = [] } = info || {};
        if (fileList?.find((_item: any) => _item.status === 'uploading')) {
          setSaveLoading(true);
        } else {
          setSaveLoading(false);
        }

        if (file.status === 'error') {
          Message.error(
            file?.response?.errorMsg ||
              $i18n.get({
                id: 'aopf.pages.platformInfoSettings.FileUploadFailed',
                dm: '文件上传失败',
              }),
          );
        }
      },
    };
  };

  const renderFormItemLabel = (label: string, tip: string, className?: string) => {
    return (
      <div className={`custom-label ${className || ''}`}>
        <span className="name">{label}</span>
        {tip && (
          <Popover
            content={
              <div
                style={{
                  maxWidth: '310px',
                  fontSize: '12px',
                  lineHeight: '16px',
                  color: '#474A52',
                }}
              >
                {tip}
              </div>
            }
          >
            <QuestionCircleOutlined />
          </Popover>
        )}
      </div>
    );
  };

  const renderUploadImageItem = (v: any) => {
    return (
      <>
        {renderFormItemLabel(v.label, v.tip, 'upload-image-form-item-label')}
        <div key={v.name} className="upload-image-form-item">
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) => prevValues[v.name] !== curValues[v.name]}
          >
            {() => {
              const imgInfo = form.getFieldValue(v.name)?.[0];
              const publicUrl = imgInfo?.publicUrl;
              return (
                <Form.Item name={v.name} rules={v.rules || []} {...commonUploadConfig}>
                  <Upload
                    {...getUploadConfig(
                      v.uploadConfig.accept,
                      v.uploadConfig.maxSize,
                      v.upLoadType,
                    )}
                    listType="picture-card"
                    showUploadList={false}
                  >
                    {publicUrl ? (
                      <div className="custom-upload-image-list">
                        <img src={publicUrl} />
                        <div className="custom-upload-image-mask">
                          <EditOutlined />
                          <DeleteOutlined
                            onClick={(e) => {
                              e.stopPropagation();
                              form.setFieldValue(v.name, []);
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="upload-image-handle">
                        <PlusOutlined />
                        <span className="text">
                          {$i18n.get({
                            id: 'aopf.pages.platformInfoSettings.UploadImages',
                            dm: '上传图片',
                          })}
                        </span>
                      </div>
                    )}
                  </Upload>
                </Form.Item>
              );
            }}
          </Form.Item>

          <div className="upload-image-desc">
            <div>
              {$i18n.get({
                id: 'aopf.pages.platformInfoSettings.SupportedFileTypes',
                dm: '支持的文件类型:',
              })}
              {v.uploadConfig.accept.join(' / ')}
            </div>
            <div>{v.uploadConfig.sizeInfo}</div>
            <div>
              {$i18n.get({ id: 'aopf.pages.platformInfoSettings.MaximumSize', dm: '最大大小:' })}
              {v.uploadConfig.maxSize}KB
            </div>
            <div>{v.uploadConfig.bgInfo}</div>
          </div>
        </div>
      </>
    );
  };

  const renderUploadFileItem = (v: any) => {
    return (
      <div key={v.name} className="upload-file-form-item">
        <Form.Item
          label={renderFormItemLabel(v.label, v.tip || '')}
          name={v.name}
          key={v.name}
          {...commonUploadConfig}
          rules={v.rules || []}
        >
          <Upload {...getUploadConfig(v.accept, v.maxSize, v.upLoadType)}>
            <div className="upload-file-trigger">
              <Button className="upload-file-btn">
                <Icon type="upload" size="xs" />
                {v.upLoadType.includes('SSL_')
                  ? $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.UploadCertificate',
                      dm: '上传',
                    })
                  : $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.UploadLocalFiles',
                      dm: '上传本地文件',
                    })}
              </Button>
              {v.showViewSample && (
                <a
                  className="view-sample-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    v.showViewSample();
                  }}
                >
                  {$i18n.get({ id: 'aopf.pages.platformInfoSettings.ViewSample', dm: '查看样例' })}
                </a>
              )}
            </div>
          </Upload>
        </Form.Item>
      </div>
    );
  };

  const goToGuide = () => {
    window.open('//www.alibabacloud.com/help/superapp/superapp-bap-public-intl/user-guide/config-guide');
  };

  const getByteCount = (str?: string) => {
    if (!str) return 0;
    return str?.replace(/[^\x00-\xff]/g, 'aa')?.length || 0;
  };

  return (
    <div className="platform-info-settings-page">
      <CommonHeader
        title={$i18n.get({ id: 'aopf.pages.platformInfoSettings.Settings', dm: '设置' })}
        breadcrumbs={breadcrumbConfig}
      />

      <div className="platform-info-settings-page-content">
        {loading ? (
          <Spin spinning />
        ) : (
          <>
            <div className="content-container">
              <Form form={form} layout="vertical">
                {/* 域名 */}
                <div className="custom-domain-form-item">
                  <div className="custom-label-content">
                    {$i18n.get({ id: 'aopf.pages.platformInfoSettings.UrlAddress', dm: 'URL地址' })}
                  </div>
                  <Form.Item hidden name="id">
                    <Input />
                  </Form.Item>
                  <Form.Item hidden name="cname">
                    <Input />
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, curValues) =>
                      prevValues.cname !== curValues.cname ||
                      prevValues.domain !== curValues.domain ||
                      prevValues.sslCertPath !== curValues.sslCertPath ||
                      prevValues.sslKeyPath !== curValues.sslKeyPath
                    }
                  >
                    {() => {
                      const cname = form.getFieldValue('cname');
                      const updateDomain = form.getFieldValue('domain') !== config.domain;
                      const needUpdatePublic =
                        form.getFieldValue('sslCertPath')?.[0]?.status === 'done' &&
                        form.getFieldValue('sslCertPath')?.[0]?.url === config.sslCertPath;
                      const needUpdatePrivate =
                        form.getFieldValue('sslKeyPath')?.[0]?.status === 'done' &&
                        form.getFieldValue('sslKeyPath')?.[0]?.url === config.sslKeyPath;
                      return (
                        <>
                          <div className="custom-domain-form-item-content">
                            <Form.Item
                              name="domain"
                              className="domain-form-item"
                              label={renderFormItemLabel(
                                $i18n.get({
                                  id: 'aopf.pages.platformInfoSettings.UrlAddress',
                                  dm: 'URL地址',
                                }),
                                $i18n.get({
                                  id: 'aopf.pages.platformInfoSettings.YouCanModifyTheUrl',
                                  dm: '可修改应用平台的URL地址',
                                }),
                              )}
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (!value) {
                                      return Promise.reject(
                                        new Error(
                                          $i18n.get({
                                            id: 'aopf.pages.platformInfoSettings.FillInTheUrl',
                                            dm: '请输入 URL 地址',
                                          }),
                                        ),
                                      );
                                    }
                                    const urlPattern =
                                      /^(https:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})$/;
                                    if (!urlPattern.test(`https://${value}`)) {
                                      return Promise.reject(
                                        new Error(
                                          $i18n.get({
                                            id: 'aopf.pages.platformInfoSettings.EnterAUrlInThe',
                                            dm: '请输入正确的URL地址',
                                          }),
                                        ),
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <Input
                                addonBefore="https://"
                                placeholder={$i18n.get({
                                  id: 'aopf.pages.platformInfoSettings.EnterAnAddress',
                                  dm: '请输入您要配置的 URL 地址，这些设置仅在自定义 URL 下生效',
                                })}
                                onBlur={() => {
                                  form.validateFields(['domain', 'sslCertPath', 'sslKeyPath']);
                                  if (updateDomain) {
                                    form.setFieldValue('cname', '');
                                  }
                                }}
                              />
                            </Form.Item>
                            {renderUploadFileItem({
                              name: 'sslCertPath',
                              label: $i18n.get({
                                id: 'aopf.pages.platformInfoSettings.PublicKeyCertificate',
                                dm: '公钥证书',
                              }),
                              tip: $i18n.get({
                                id: 'aopf.pages.platformInfoSettings.ThePublicKeyCertificateContains',
                                dm: '公钥证书包含证书的公钥和签名等信息。负载均衡SLB使用NGINX格式的证书，通常从证书提供商获取到的NGNIX格式的证书文件中以.pem为后缀（有些可能以.crt或其他格式为后缀）。',
                              }),
                              type: 'uploadFile',
                              accept: ['.pem', '.crt'],
                              upLoadType: 'SSL_CERT',
                              rules: [
                                {
                                  validator: (_, value) => {
                                    if (!value?.length) {
                                      return Promise.reject(
                                        new Error(
                                          $i18n.get({
                                            id: 'aopf.pages.platformInfoSettings.PleaseUploadTheCertificateInformation',
                                            dm: '请上传公钥证书',
                                          }),
                                        ),
                                      );
                                    }
                                    if (updateDomain && needUpdatePublic) {
                                      return Promise.reject(
                                        new Error(
                                          $i18n.get({
                                            id: 'aopf.pages.platformInfoSettings.TheUrlAddressHasBeen',
                                            dm: 'URL已更新，请更新证书信息',
                                          }),
                                        ),
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ],

                              showViewSample: () => setView([true, 'sslCertPath']),
                            })}
                            {renderUploadFileItem({
                              name: 'sslKeyPath',
                              label: $i18n.get({
                                id: 'aopf.pages.platformInfoSettings.PrivateKeyCertificate',
                                dm: '私钥',
                              }),
                              tip: $i18n.get({
                                id: 'aopf.pages.platformInfoSettings.ThePrivateKeyOfThe',
                                dm: '证书的私钥，通常从证书提供商获取到NGINX格式的证书文件中以.key为后缀。',
                              }),
                              type: 'uploadFile',
                              accept: ['.key'],
                              upLoadType: 'SSL_KEY',
                              rules: [
                                {
                                  validator: async (_, value) => {
                                    if (!value?.length) {
                                      return Promise.reject(
                                        new Error(
                                          $i18n.get({
                                            id: 'aopf.pages.platformInfoSettings.PleaseUploadTheCertificateInformation1',
                                            dm: '请上传私钥证书',
                                          }),
                                        ),
                                      );
                                    }
                                    if (updateDomain && needUpdatePrivate) {
                                      return Promise.reject(
                                        new Error(
                                          $i18n.get({
                                            id: 'aopf.pages.platformInfoSettings.TheUrlAddressHasBeen',
                                            dm: 'URL已更新，请更新证书信息',
                                          }),
                                        ),
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ],

                              showViewSample: () => setView([true, 'sslKeyPath']),
                            })}
                          </div>
                          {cname ? (
                            <div className="dns-item">
                              <Popover
                                content={
                                  <div
                                    style={{
                                      maxWidth: '310px',
                                      fontSize: '12px',
                                      lineHeight: '16px',
                                      color: '#474A52',
                                      wordBreak: 'break-all',
                                    }}
                                  >
                                    DNS: {cname}
                                  </div>
                                }
                                placement="topLeft"
                              >
                                <div className="dns-label">DNS: {cname}</div>
                              </Popover>
                              <div className="dns-action">
                                <a
                                  onClick={() =>
                                    window.open(
                                      '//www.alibabacloud.com/help/superapp/superapp-bap-public-intl/user-guide/dns-config-guide',
                                    )
                                  }
                                >
                                  {$i18n.get({
                                    id: 'aopf.pages.platformInfoSettings.ConfigurationDocumentation',
                                    dm: '配置文档指引',
                                  })}
                                </a>
                                <Icon
                                  type="copy--outline"
                                  size="xs"
                                  onClick={(e) => copy(cname, e)}
                                />
                              </div>
                            </div>
                          ) : (
                            <>
                              <Button
                                className="custom-domain-btn"
                                loading={dnsLoading}
                                onClick={() => queryDns()}
                                style={{
                                  borderColor: notInvalid ? '#C82727' : 'var(--superapp-primary-1)',
                                  color: notInvalid ? '#C82727' : 'var(--superapp-primary-1)',
                                }}
                              >
                                {dnsLoading
                                  ? $i18n.get({
                                      id: 'aopf.pages.platformInfoSettings.ObtainingDns',
                                      dm: '正在获取DNS',
                                    })
                                  : $i18n.get({
                                      id: 'aopf.pages.platformInfoSettings.ObtainTheDnsAddress',
                                      dm: '获取DNS地址',
                                    })}
                              </Button>
                              {notInvalid && (
                                <div className="dns-not-invalid-info">
                                  {$i18n.get({
                                    id: 'aopf.pages.platformInfoSettings.YouHaveNotCompletedThe',
                                    dm: '您尚未完成域名所有权的验证，无法获取DNS信息，请先完成域名所有权验证后重试。',
                                  })}

                                  <a
                                    onClick={() =>
                                      window.open(
                                        '//www.alibabacloud.com/help/superapp/superapp-bap-public-intl/user-guide/verify-the-ownership-of-a-domain-name',
                                      )
                                    }
                                  >
                                    {$i18n.get({
                                      id: 'aopf.pages.platformInfoSettings.HowDoIPerformDomain',
                                      dm: '如何进行域名所有权验证？',
                                    })}
                                  </a>
                                </div>
                              )}
                            </>
                          )}
                        </>
                      );
                    }}
                  </Form.Item>
                </div>
                {/* 客户名称 */}
                <Form.Item
                  name="customerName"
                  label={renderFormItemLabel(
                    $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.CustomerName',
                      dm: '客户名称',
                    }),
                    $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.YouCanModifyThePart',
                      dm: '可修改平台涉及到客户名称的部分，包括平台名称、标签页名称等',
                    }),
                  )}
                  rules={[
                    {
                      validator: async (_, value) => {
                        if(!value) return Promise.resolve();
                        const valueLength = getByteCount(value);
                        const isValid = valueLength <= 40 && valueLength >=2;
                        if (!isValid)
                          return Promise.reject(
                            new Error(
                              $i18n.get({
                                id: 'aopf.pages.platformInfoSettings.EnterACustomerNameThat1',
                                dm: '输入内容超过限制',
                              }),
                            ),
                          );
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    showCount={{
                      formatter: ({ value }) => `${getByteCount(value)}/40`,
                    }}
                    placeholder={$i18n.get({
                      id: 'aopf.pages.platformInfoSettings.EnterACustomerNameThat',
                      dm: '请输入客户名称（2-40 字符）',
                    })}
                    // maxLength={40}
                  />
                </Form.Item>
                {/* 品牌logo */}
                {renderUploadImageItem({
                  name: 'brandLogoPath',
                  label: $i18n.get({
                    id: 'aopf.pages.platformInfoSettings.BrandLogo',
                    dm: '品牌logo',
                  }),
                  tip: $i18n.get({
                    id: 'aopf.pages.platformInfoSettings.YouCanModifyAllLogo',
                    dm: '可修改所有Logo样式，包括空间图标，登录页图标、标签页图标等',
                  }),
                  upLoadType: 'LOGO',
                  uploadConfig: {
                    accept: ['.png', '.jpg', '.jpeg'],
                    sizeInfo: $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.SizePixels',
                      dm: '尺寸:  180 * 180像素',
                    }),
                    maxSize: 120,
                    bgInfo: $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.BackgroundOpaque',
                      dm: '背景:  不透明',
                    }),
                  },
                })}
                {/* 主题颜色 */}
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, curValues) =>
                    prevValues.primaryColor !== curValues.primaryColor
                  }
                >
                  {() => {
                    return (
                      <Form.Item
                        name="primaryColor"
                        className="primary-color-form-item"
                        label={renderFormItemLabel(
                          $i18n.get({
                            id: 'aopf.pages.platformInfoSettings.ThemeColor',
                            dm: '主题颜色',
                          }),
                          $i18n.get({
                            id: 'aopf.pages.platformInfoSettings.YouCanModifyTheTheme',
                            dm: '可修改主题颜色，包括登录页和平台内的主题颜色',
                          }),
                        )}
                        rules={[
                          {
                            pattern: /^#[a-fA-F0-9]{6}$/,
                            message: $i18n.get({
                              id: 'aopf.pages.platformInfoSettings.EnterAHexadecimalColorValue',
                              dm: '请输入正确格式的主题色，例如：#FFFFFF 或 #000000',
                            }),
                          },
                        ]}
                      >
                        <Input
                          className="has-color-preview"
                          placeholder={$i18n.get({
                            id: 'aopf.pages.platformInfoSettings.EnterAHexadecimalColorValue.1',
                            dm: '请输入16进制色值',
                          })}
                          addonAfter={
                            <div
                              className="color-preview"
                              style={{ backgroundColor: form.getFieldValue('primaryColor') }}
                            />
                          }
                        />
                      </Form.Item>
                    );
                  }}
                </Form.Item>
                {/* 条款和协议 */}
                <div className="form-item-has-children">
                  {renderFormItemLabel(
                    $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.TermsAndAgreements',
                      dm: '条款和协议',
                    }),
                    $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.SupportUploadingAndAddingYour',
                      dm: '支持上传新增自己的服务条款和隐私协议',
                    }),
                  )}
                  {renderUploadFileItem({
                    name: 'termsServicePath',
                    label: $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.TermsOfService',
                      dm: '服务条款',
                    }),
                    type: 'uploadFile',
                    accept: [],
                    upLoadType: 'TERMS_SERVICE',
                  })}
                  {renderUploadFileItem({
                    name: 'privacyPolicyPath',
                    label: $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.PrivacyAgreement',
                      dm: '隐私协议',
                    }),
                    type: 'uploadFile',
                    accept: [],
                    upLoadType: 'PRIVACY_POLICY',
                  })}
                </div>
                {/* 登录页和注册页标题 */}
                <Form.Item
                  name="loginTitle"
                  label={renderFormItemLabel(
                    $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.LoginPageAndRegistrationPage',
                      dm: '登录页和注册页标题',
                    }),
                    $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.YouCanModifyTheTitle',
                      dm: '可修改登录页和注册页的标题',
                    }),
                  )}
                  rules={[
                    {
                      validator: async (_, value) => {
                        if(!value) return Promise.resolve();
                        const valueLength = getByteCount(value);
                        const isValid = valueLength <= 40 && valueLength >=2;
                        if (!isValid)
                          return Promise.reject(
                            new Error(
                              $i18n.get({
                                id: 'aopf.pages.platformInfoSettings.EnterACustomerNameThat1',
                                dm: '输入内容超过限制',
                              }),
                            ),
                          );
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    showCount={{
                      formatter: ({ value }) => `${getByteCount(value)}/40`,
                    }}
                    placeholder={$i18n.get({
                      id: 'aopf.pages.platformInfoSettings.EnterATitleThatCannot',
                      dm: '请输入登录页和注册页标题名称（2-40 字符）',
                    })}
                  />
                </Form.Item>
                {/* 登录页和注册页文案 */}
                <Form.Item
                  name="loginDescp"
                  label={renderFormItemLabel(
                    $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.LoginPageAndRegistrationPage.1',
                      dm: '登录页和注册页文案',
                    }),
                    $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.YouCanModifyTheText',
                      dm: '可修改登录页和注册页的文案介绍',
                    }),
                  )}
                  rules={[
                    {
                      validator: async (_, value) => {
                        if(!value) return Promise.resolve();
                        const valueLength = getByteCount(value);
                        const isValid = valueLength <= 200 && valueLength >=2;
                        if (!isValid)
                          return Promise.reject(
                            new Error(
                              $i18n.get({
                                id: 'aopf.pages.platformInfoSettings.EnterACustomerNameThat1',
                                dm: '输入内容超过限制',
                              }),
                            ),
                          );
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input.TextArea
                    showCount={{
                      formatter: ({ value }) => `${getByteCount(value)}/200`,
                    }}
                    rows={4}
                    placeholder={$i18n.get({
                      id: 'aopf.pages.platformInfoSettings.PleaseEnterACopyOf',
                      dm: '请输入登录页和注册页文案介绍（2-200 字符）',
                    })}
                  />
                </Form.Item>
                {/* 登录页和注册页图片 */}
                {renderUploadImageItem({
                  name: 'loginImgPath',
                  label: $i18n.get({
                    id: 'aopf.pages.platformInfoSettings.ImageOfLoginPageAnd',
                    dm: '登录页和注册页图片',
                  }),
                  tip: $i18n.get({
                    id: 'aopf.pages.platformInfoSettings.YouCanModifyTheImage',
                    dm: '可修改登录页和注册页的图片',
                  }),
                  upLoadType: 'LOGIN_IMG',
                  uploadConfig: {
                    accept: ['.png'],
                    sizeInfo: $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.ImageRatioReferenceSizePixels',
                      dm: '图片比例：3 : 2；参考尺寸:  1686 * 1124像素',
                    }),
                    maxSize: 500,
                    bgInfo: $i18n.get({
                      id: 'aopf.pages.platformInfoSettings.BackgroundTransparent',
                      dm: '背景:  透明',
                    }),
                  },
                })}
              </Form>
            </div>
            <div className="platform-info-settings-page-footer">
              <Button type="primary" disabled={saveLoading} onClick={querySaveConfig}>
                {$i18n.get({ id: 'aopf.pages.platformInfoSettings.Save', dm: '保存' })}
              </Button>
              <Button onClick={queryConfig}>
                {$i18n.get({ id: 'aopf.pages.platformInfoSettings.Cancel', dm: '取消' })}
              </Button>
            </div>
          </>
        )}
      </div>

      <Modal
        title={$i18n.get({ id: 'aopf.pages.platformInfoSettings.ViewSample', dm: '查看样例' })}
        width={640}
        closable={false}
        open={viewVisible}
        onCancel={() => setView([false, ''])}
        footer={[
          <Button onClick={() => setView([false, ''])}>
            {$i18n.get({ id: 'aopf.pages.platformInfoSettings.Cancel', dm: '取消' })}
          </Button>,
        ]}
        wrapClassName="custom-superapp-antd-modal-wrap platform-info-settings-page-modal"
      >
        {viewType === 'sslCertPath' ? (
          <>
            <div className="introduce">
              {$i18n.get({
                id: 'aopf.pages.platformInfoSettings.TheCertificateFileYouObtain',
                dm: '您从证书服务商获取的证书文件中通常包含您自己的证书和中级签发机构的证书，通常称为证书链，上传证书时，需要确保上传完整的证书链。',
              })}

              <br />
              {$i18n.get({
                id: 'aopf.pages.platformInfoSettings.SlbIsCompatibleWithNginx',
                dm: '负载均衡SLB兼容NGINX格式证书文件，您可以直接上传NGINX格式的证书。',
              })}

              <br />
              {$i18n.get({
                id: 'aopf.pages.platformInfoSettings.GenerallyTheFormatIsAs',
                dm: '通常格式如下，注意灰色背景部分为证书文件标识符，不可省略。',
              })}
            </div>
            <div className="gary-text">-----BEGIN CERTIFICATE-----</div>
            <div className="white-text">
              {$i18n.get({
                id: 'aopf.pages.platformInfoSettings.ServerPublicKeyCertificateBase',
                dm: '服务器公钥证书（BASE64编码）',
              })}
            </div>
            <div className="gary-text">-----END CERTIFICATE -----</div>
            <div className="white-text">
              <Icon type="warning--outline" size="xs" />
              {$i18n.get({
                id: 'aopf.pages.platformInfoSettings.DonTBeFreeIn',
                dm: '！！！中间不可有空行！！！',
              })}
            </div>
            <div className="gary-text">-----BEGIN CERTIFICATE-----</div>
            <div className="white-text">
              {$i18n.get({
                id: 'aopf.pages.platformInfoSettings.IntermediateIssuingAuthorityPublicKey',
                dm: '中级签发机构公钥证书（BASE64编码）',
              })}
            </div>
            <div className="gary-text">-----END CERTIFICATE-----</div>
          </>
        ) : (
          <>
            <div className="introduce">
              {$i18n.get({
                id: 'aopf.pages.platformInfoSettings.SlbIsCompatibleWithNginx.1',
                dm: '负载均衡SLB兼容NGINX格式证书文件，您可以直接上传NGINX格式的证书私钥通常格式如下，注意灰色背景部分为证书私钥文件标识符，不可省略',
              })}
            </div>
            <div className="gary-text">-----BEGIN RSA PRIVATE KEY-----</div>
            <div className="white-text">
              {$i18n.get({
                id: 'aopf.pages.platformInfoSettings.CertificatePrivateKeyBaseEncoded',
                dm: '证书私钥（BASE64编码）',
              })}
            </div>
            <div className="gary-text">-----END RSA PRIVATE KEY-----</div>
          </>
        )}
      </Modal>

      <Modal
        title={$i18n.get({ id: 'aopf.pages.platformInfoSettings.UrlConfiguration', dm: 'URL配置' })}
        width={440}
        open={guideVisible}
        onCancel={() => setGuideVisible(false)}
        footer={[
          <Button type="primary" onClick={goToGuide}>
            {$i18n.get({ id: 'aopf.pages.platformInfoSettings.GoNow', dm: '立即前往' })}
          </Button>,
        ]}
        wrapClassName="custom-superapp-antd-modal-wrap"
      >
        <div>
          {$i18n.get({
            id: 'aopf.pages.platformInfoSettings.ToEnsureThatTheUrl',
            dm: '为了确保正确配置URL，请务必前往文档中心仔细阅读操作步骤',
          })}

          <a
            onClick={goToGuide}
            style={{
              marginLeft: '6px',
              textDecoration: 'underline',
              color: 'var(--superapp-primary-1)',
            }}
          >
            {$i18n.get({
              id: 'aopf.pages.platformInfoSettings.UrlConfigurationGuide',
              dm: '品牌白标配置指南',
            })}
          </a>
        </div>
      </Modal>
    </div>
  );
};

export default PlatformInfoSettings;
